import { gql } from "@apollo/client";

import { AiCategory } from "../types";

export const generateExerciseQuery = gql`
    query GenerateExercise($photo: Upload!, $categories: [String!]!, $history: [String!], $excluded: [String!], $favorite: [String!]) {
        generateExercise(photo: $photo, categories: $categories, history: $history, excluded: $excluded, favorite: $favorite) {
            exercise {
                name
                instructions
            }
            polling_id
            error
        }
    }
`;

export interface GenerateExerciseQueryVariables {
    photo: Blob;
    categories: ReadonlyArray<AiCategory>;
    history: ReadonlyArray<string> | null;
    excluded: ReadonlyArray<string> | null;
    favorite: ReadonlyArray<string> | null;
}

export interface GenerateExerciseQueryType {
    generateExercise: {
        exercise?: {
            name?: string;
            instructions?: string;
        };
        polling_id?: string;
        error?: string;
    };
}

export const pollQuery = gql`
    query PollQuery($pollingId: String!) {
        poll(id: $pollingId) {
            reskined_image_url
        }
    }
`;

export interface PollQueryVariables {
    pollingId: string;
}

export interface PollQueryType {
    poll: {
        reskined_image_url?: string;
    };
}
